<header class="main-header">
  <!-- Header Navbar: style can be found in header.less -->
  <nav class="navbar navbar-fixed-top">
    <!-- Sidebar toggle button-->
    <div class="toggle" style="z-index: 20000;">
      <a
        (click)="toggleNavbar()"
        #togglenavbar
        id="toggle-navbar"
        class="sidebar-toggle"
        data-toggle="push-menu"
        role="button"
      >
        <span class="sr-only">Toggle navigation</span>
      </a>
    </div>
    <div class="main_logo ">
      <a class="logo d-none d-sm-block">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini"
          ><img src="./../../../assets/images/logo-white.png" alt=""
        /></span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg d-none d-sm-block"
          ><img src="assets/images/logo-white.png" alt="" />
          <span style="padding-left: 12px; font-size: 13px; font-weight: bold;"
            >CE HUB</span
          >
        </span>
      </a>
    </div>
    <div class="page_name"></div>
    <!-- Navbar Right Menu -->
    <div class="navbar-custom-menu text-right">
      <ul class="nav navbar-nav">
        <li class="dropdown user user-menu" style="margin-top: 7px">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            <!-- <img
              src="assets/images/default.png"
              class="user-image"
              alt="User Image"
            /> -->
            <i class="fa fa-user-circle-o" style="font-size: 18px;"></i>
            <i class="fa fa-circle text-success side_top"></i>
            <span class="hidden-xs head_log" style="margin-left: 4px;"
              >{{ user?.user?.firstName }} {{ user?.user?.lastName }}
            </span>
          </a>
          <ul class="dropdown-menu">
            <!-- User image -->
            <li class="user-header">
              <img
                src="assets/images/default.png"
                class="img-circle"
                alt="User Image"
              />

              <p>
                <i class="fa fa-user"></i> {{ user?.user?.firstName }}
                {{ user?.user?.lastName }}
                <br />
                <i class="fa fa-database"></i>
                {{ user?.scac }}
                <br />
                <i class="fa fa-tasks"></i> {{ user?.user?.role?.role }}
              </p>
              <p></p>
            </li>

            <li class="user-footer">
              <!-- <div class="pull-left">
                <a href="#" class="btn btn-default btn-flat"
                  ><i class="fa fa-user"></i> Profile</a
                >
              </div> -->
              <div class="pull-right">
                <a (click)="logout()" class="btn btn-default btn-flat">
                  <i class="fa fa-power-off"></i> Sign out</a
                >
              </div>
            </li>
          </ul>
        </li>

        <!-- Notifications: style can be found in dropdown.less -->
        <li class="dropdown notifications-menu">
          <!-- <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-bell-o notification-bell" [ngClass]="classes" id="alert-bell"></i>
            <span class="label label-warning notification-label">{{messages.length}}</span>
          </a> -->
          <ul class="dropdown-menu">
            <li class="header">
              <h3>Notification</h3>
              <span>Mark All as Read</span>
            </li>
            <li>
              <!-- inner menu: contains the actual data -->
              <ul class="menu">
                <li *ngIf="!messages || messages.length == 0">
                  <a >
                    <img
                      src="assets/images/avatar2.png"
                      class="user-image1"
                      alt="User Image"
                    />
                    No New Messages
                  </a>
                </li>
                <li *ngFor="let message of messages">
                  <div class="row">
                    <div class="col-8">
                      <a  style="font-size: 11px">
                        <i class="fa fa-check"></i>
                        {{ message?.body?.timeTracker?.driver }} [BOL -
                        {{ message?.body?.billofladingDTO?.billOfLadingId }}]
                      </a>
                    </div>
                    <div class="col-4">
                      <button class="details" 
                      (click)="this.router.navigateByUrl('/map-comparison')"> 
                        Details
                       </button>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
            <li class="footer"><a >View all</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</header>
